import { ref } from 'vue';
import { useStore } from 'vuex';

export function useIdentityThreeOperations() {
  const store = useStore();
  const carrierId = ref(null);
  const companyId = ref(null);
  const onboardingPackeId = ref(null);

  const handleCreate = (field, value, isType) => {
    const module = getModuleName(field);
    return store.dispatch(`${module}/create${field}`, {
      carrierId: carrierId.value,
      value,
      isType,
      companyId: companyId.value,
      onboardingPackeId: onboardingPackeId.value,
    });
  };

  const handleUpdate = (field, id, value, isType) => {
    const module = getModuleName(field);
    return store.dispatch(`${module}/update${field}`, {
      id,
      carrierId: carrierId.value,
      value,
      isType,
      companyId: companyId.value,
    });
  };

  const handleDelete = (field, id) => {
    const module = getModuleName(field);
    return store.dispatch(`${module}/delete${field}`, id);
  };

  const getModuleName = (field) => {
    return field.toLowerCase() + 's';
  };

  const saveData = async (
    fields,
    carrier_id,
    company_id,
    onboarding_packet_id
  ) => {
    console.log(fields);

    carrierId.value = carrier_id;
    companyId.value = company_id;
    onboardingPackeId.value = onboarding_packet_id;

    const emailPromises = fields.emails.map((email) => {
      if (!email.id) {
        return handleCreate('Email', email.value, 'rate_confirmation');
      } else {
        return handleUpdate(
          'Email',
          email.id,
          email.value,
          'rate_confirmation'
        );
      }
    });

    const phonePromises = fields.phones.map((phone) => {
      if (!phone.id) {
        return handleCreate('Phone', phone.value, 'rate_confirmation');
      } else {
        return handleUpdate(
          'Phone',
          phone.id,
          phone.value,
          'rate_confirmation'
        );
      }
    });

    const domainPromises = fields.domains.map((domain) => {
      if (!domain.id) {
        return handleCreate('Domain', domain.value);
      } else {
        return handleUpdate('Domain', domain.id, domain.value);
      }
    });

    await Promise.all([...emailPromises, ...phonePromises, ...domainPromises]);
  };

  const getModifiedFields = (stored, fields) => {
    const modifiedFields = {
      emails: [],
      phones: [],
      domains: [],
    };

    const checkModifications = (storedArray = [], fieldsArray, type) => {
      const storedMap = new Map();
      storedArray.forEach((item) => storedMap.set(item.id, item));

      // Iterate over the fieldsArray to identify new and modified items
      fieldsArray.forEach((fieldItem) => {
        const storedItem = storedMap.get(fieldItem.id);
        if (!fieldItem.id || !storedItem) {
          // If there is no stored item with the same ID, or if item has no ID, it's new
          modifiedFields[type].push(fieldItem);
        } else if (storedItem.value !== fieldItem.value) {
          // If the values are different, it's modified
          modifiedFields[type].push(fieldItem);
        }
      });
    };

    checkModifications(stored.emails, fields.emails, 'emails');
    checkModifications(stored.phones, fields.phones, 'phones');
    checkModifications(stored.domains, fields.domains, 'domains');

    return modifiedFields;
  };

  return {
    handleCreate,
    handleUpdate,
    handleDelete,
    saveData,
    carrierId,
    getModifiedFields,
  };
}
